import { Radio as FlowBiteRadio, Label, RadioProps } from 'flowbite-react';
import React, { useId } from 'react';
import { radioButtonTheme } from '../../styles/themes/radio-button';

export type RadioButtonProps = Omit<RadioProps, 'defaultChecked'> & {
    testId?: string;
    ariaLabel?: string;
    label?: React.ReactNode;
    value: string;
    disabled?: boolean;
};

export const RadioButton: React.FC<RadioButtonProps> = ({
    testId,
    ariaLabel,
    label,
    disabled,
    onChange,
    value,
    ...props
}) => {
    const id = useId();

    return (
        <span className='flex items-center'>
            <FlowBiteRadio
                id={id}
                data-testid={testId}
                aria-label={ariaLabel}
                className={`${radioButtonTheme.root.base} ${radioButtonTheme.style.auto}`}
                disabled={disabled}
                onChange={(e) => onChange && onChange(e)}
                value={value}
                {...props}
            />
            {
                <Label htmlFor={id} disabled={disabled}>
                    {label}
                </Label>
            }
        </span>
    );
};
